import { message } from 'antd'
import { useContext, useRef, useState, forwardRef, useImperativeHandle, useEffect, useMemo } from 'react'
import PSAIModal from '@PSAIComponents/PSAIModal'
import { RESOURCE_TYPE, IMAGE_TYPE, COMMODITY_SCENE_MODE, RESOURCE_PARAMS } from '@utils/CONST'
import CustomModelForm from "../CustomModelForm2";
import Matting from "../Matting";
import Crop from "../Crop";
import Utils from '@utils/utils'
import API from "@api/api";
import eventBus from '@utils/eventBus'
import { GenerateContext } from '../../../hooks/GenerateContext';

const fetchData = (resourceType) => {
    const params = { ...RESOURCE_PARAMS[resourceType] }
    return API.getCustomResources2({
        ...params,
        pageIndex: 1,
        pageSize: 50000
    })
}

// 自定义素材自动选择
const useCustomMaterialAutoSelect = (handelOpenDrawer) => {
    const isMounted = useRef(true)
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const {
        // 试衣模特选择
        tryonModelKeyList, setTryonModelKeyList,
        // 姿势裂变参考图选择
        poseTryonKeyList, setPoseTryonKeyList,
        // 眼镜试戴参考图选择
        glassesTryonKeyList, setGlassesTryonKeyList,
        // 同版型考图选择
        simTryonKeyList, setSimTryonKeyList,
        // 模特选择
        modelKeyList, setModelKeyList,
        // 场景选择
        sceneKeyList, setSceneKeyList,
        // 鞋子选择
        shoesKeyList, setShoesKeyList,
        // 视频选择
        videoKeyList, setVideoKeyList,
        // 商品颜色选择
        colorKeyList, setColorKeyList,
        setRefImgConfig,
        setOutputRatio,
        setOutputWidth,
        setOutputHeight,
        setInputImageTransform,
    } = useContext(GenerateContext)

    const tryonModelKeyListRef = useRef(tryonModelKeyList)
    const poseTryonKeyListRef = useRef(poseTryonKeyList)
    const glassesTryonKeyListRef = useRef(glassesTryonKeyList)
    const simTryonKeyListRef = useRef(simTryonKeyList)
    const modelKeyListRef = useRef(modelKeyList)
    const sceneKeyListRef = useRef(sceneKeyList)
    const shoesKeyListRef = useRef(shoesKeyList)
    const videoKeyListRef = useRef(videoKeyList)
    const colorKeyListRef = useRef(colorKeyList)
    useEffect(() => {
        tryonModelKeyListRef.current = tryonModelKeyList
    }, [tryonModelKeyList])
    useEffect(() => {
        poseTryonKeyListRef.current = poseTryonKeyList
    }, [poseTryonKeyList])
    useEffect(() => {
        glassesTryonKeyListRef.current = glassesTryonKeyList
    }, [glassesTryonKeyList])
    useEffect(() => {
        simTryonKeyListRef.current = simTryonKeyList
    }, [simTryonKeyList])
    useEffect(() => {
        modelKeyListRef.current = modelKeyList
    }, [modelKeyList])
    useEffect(() => {
        sceneKeyListRef.current = sceneKeyList
    }, [sceneKeyList])
    useEffect(() => {
        shoesKeyListRef.current = shoesKeyList
    }, [shoesKeyList])
    useEffect(() => {
        videoKeyListRef.current = videoKeyList
    }, [videoKeyList])
    useEffect(() => {
        colorKeyListRef.current = colorKeyList
    }, [colorKeyList])

    // 自定义素材列表
    const [modelMaterialList, setModelMaterialList] = useState([])
    const [modelSceneMaterialList, setModelSceneMaterialList] = useState([])
    const [tryonModelMaterialList, setTryonModelMaterialList] = useState([])
    const [poseTryonMaterialList, setPoseTryonMaterialList] = useState([])
    const [glassesTryonMaterialList, setGlassesTryonMaterialList] = useState([])
    const [simTryonMaterialList, setSimTryonMaterialList] = useState([])
    const [tryonSceneMaterialList, setTryonSceneMaterialList] = useState([])
    const [tryonShoesMaterialList, setTryonShoesMaterialList] = useState([])
    const [videoModelMaterialList, setVideoModelMaterialList] = useState([])
    const [commoditySceneMaterialList, setCommoditySceneMaterialList] = useState([])

    // 新增自定义素材
    const appendCustomMaterial = (id, resourceType) => {
        if (resourceType == RESOURCE_TYPE.MODEL) {
            setModelMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.MODEL_SCENE) {
            setModelSceneMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
            setTryonModelMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.POSE_TRYON) {
            setPoseTryonMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.GLASSES_TRYON) {
            setGlassesTryonMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
            setSimTryonMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.TRYON_SCENE) {
            setTryonSceneMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
            setTryonShoesMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            setVideoModelMaterialList(pre => [...pre, id])
        } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            setCommoditySceneMaterialList(pre => [...pre, id])
        }
    }

    // 遍历素材状态
    const [modelLoop, setModelLoop] = useState(false)
    const [tryonModelLoop, setTryonModelLoop] = useState(false)
    const [modelSceneLoop, setModelSceneLoop] = useState(false)
    const [poseTryonLoop, setPoseTryonLoop] = useState(false)
    const [glassesTryonLoop, setGlassesTryonLoop] = useState(false)
    const [simTryonLoop, setSimTryonLoop] = useState(false)
    const [tryonSceneLoop, setTryonSceneLoop] = useState(false)
    const [tryonShoesLoop, setTryonShoesLoop] = useState(false)
    const [videoModelLoop, setVideoModelLoop] = useState(false)
    const [commoditySceneLoop, setCommoditySceneLoop] = useState(false)
    // 遍历AI模特
    useEffect(() => {
        if (!modelLoop) return
        const resourceType = RESOURCE_TYPE.MODEL
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setModelMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [modelLoop])
    // 遍历模特场景
    useEffect(() => {
        if (!modelSceneLoop) return
        const resourceType = RESOURCE_TYPE.MODEL_SCENE
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setModelSceneMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [modelSceneLoop])
    // 遍历tryon模特
    useEffect(() => {
        if (!tryonModelLoop) return
        const resourceType = RESOURCE_TYPE.TRYON_MODEL
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setTryonModelMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [tryonModelLoop])
    // 遍历poseTryon模特
    useEffect(() => {
        if (!poseTryonLoop) return
        const resourceType = RESOURCE_TYPE.POSE_TRYON
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setPoseTryonMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [poseTryonLoop])
    // 遍历glassesTryon模特
    useEffect(() => {
        if (!glassesTryonLoop) return
        const resourceType = RESOURCE_TYPE.GLASSES_TRYON
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setGlassesTryonMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [glassesTryonLoop])
    // 遍历simTryon模特
    useEffect(() => {
        if (!simTryonLoop) return
        const resourceType = RESOURCE_TYPE.SIM_TRYON
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setSimTryonMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [simTryonLoop])

    // 遍历tryon场景
    useEffect(() => {
        if (!tryonSceneLoop) return
        const resourceType = RESOURCE_TYPE.TRYON_SCENE
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setTryonSceneMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [tryonSceneLoop])
    // 遍历tryon鞋子
    useEffect(() => {
        if (!tryonShoesLoop) return
        const resourceType = RESOURCE_TYPE.TRYON_SHOES
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setTryonShoesMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [tryonShoesLoop])
    // 遍历视频模特 
    useEffect(() => {
        if (!videoModelLoop) return
        const resourceType = RESOURCE_TYPE.VIDEO_MODEL
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setVideoModelMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [videoModelLoop])
    // 遍历商品场景
    useEffect(() => {
        if (!commoditySceneLoop) return
        const resourceType = RESOURCE_TYPE.COMMODITY_SCENE
        const loopFunc = async () => {
            try {
                if (!isMounted.current) return
                await Utils.delayFunc(1000)
                if (!isMounted.current) return
                const res = await fetchData(resourceType)
                if (!isMounted.current) return
                if (res.code != 0) throw new Error(err.message)
                const list = res.data?.items || []
                const successList = list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true))
                if (!isMounted.current) return
                setCommoditySceneMaterialList(pre => {
                    const temp = [...pre]
                    const res = temp.filter(item => {
                        const index = successList.findIndex(i => i.id == item)
                        if (index == -1) return true
                        handleSelect(successList[index], resourceType)
                        return false
                    })
                    if (res.length != 0) loopFunc()
                    return res
                })
            } catch (err) {
                console.error(err)
            }
        }
        loopFunc()
    }, [commoditySceneLoop])
    // 触发loop
    useEffect(() => {
        if (commoditySceneMaterialList.length == 0) setCommoditySceneLoop(false)
        else setCommoditySceneLoop(true)
    }, [commoditySceneMaterialList])
    useEffect(() => {
        if (videoModelMaterialList.length == 0) setVideoModelLoop(false)
        else setVideoModelLoop(true)
    }, [videoModelMaterialList])
    useEffect(() => {
        if (tryonShoesMaterialList.length == 0) setTryonShoesLoop(false)
        else setTryonShoesLoop(true)
    }, [tryonShoesMaterialList])
    useEffect(() => {
        if (tryonSceneMaterialList.length == 0) setTryonSceneLoop(false)
        else setTryonSceneLoop(true)
    }, [tryonSceneMaterialList])
    useEffect(() => {
        if (modelSceneMaterialList.length == 0) setModelSceneLoop(false)
        else setModelSceneLoop(true)
    }, [modelSceneMaterialList])
    useEffect(() => {
        if (modelMaterialList.length == 0) setModelLoop(false)
        else setModelLoop(true)
    }, [modelMaterialList])
    useEffect(() => {
        if (tryonModelMaterialList.length == 0) setTryonModelLoop(false)
        else setTryonModelLoop(true)
    }, [tryonModelMaterialList])
    useEffect(() => {
        if (poseTryonMaterialList.length == 0) setPoseTryonLoop(false)
        else setPoseTryonLoop(true)
    }, [poseTryonMaterialList])
    useEffect(() => {
        if (glassesTryonMaterialList.length == 0) setGlassesTryonLoop(false)
        else setGlassesTryonLoop(true)
    }, [glassesTryonMaterialList])
    useEffect(() => {
        if (simTryonMaterialList.length == 0) setSimTryonLoop(false)
        else setSimTryonLoop(true)
    }, [simTryonMaterialList])


    // 是否多选
    const getMultiple = (type) => {
        if (type == RESOURCE_TYPE.TRYON_MODEL) return true
        if (type == RESOURCE_TYPE.POSE_TRYON) return true
        if (type == RESOURCE_TYPE.GLASSES_TRYON) return false
        if (type == RESOURCE_TYPE.SIM_TRYON) return false
        if (type == RESOURCE_TYPE.MODEL) return false
        if (type == RESOURCE_TYPE.TRYON_SCENE) return false
        if (type == RESOURCE_TYPE.TRYON_SHOES) return true
        if (type == RESOURCE_TYPE.COMMODITY_COLOR || type == RESOURCE_TYPE.CLOTH_RECOLOR) return false
        return false
    }
    // 最大数量
    const maxCount = useRef(5)
    const getChangeFunc = (type) => {
        if (type == RESOURCE_TYPE.TRYON_MODEL) return setTryonModelKeyList
        if (type == RESOURCE_TYPE.POSE_TRYON) return setPoseTryonKeyList
        if (type == RESOURCE_TYPE.GLASSES_TRYON) return setGlassesTryonKeyList
        if (type == RESOURCE_TYPE.SIM_TRYON) return setSimTryonKeyList
        if (type == RESOURCE_TYPE.MODEL) return setModelKeyList
        if (type == RESOURCE_TYPE.TRYON_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.MODEL_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.TRYON_SHOES) return setShoesKeyList
        if (type == RESOURCE_TYPE.VIDEO_MODEL) return setVideoKeyList
        if (type == RESOURCE_TYPE.COMMODITY_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.COMMODITY_COLOR || type == RESOURCE_TYPE.CLOTH_RECOLOR) return setColorKeyList
    }

    // 上传后自动选中
    const handleSelect = (item, resourceType) => {
        const multiple = getMultiple(resourceType)
        const onChange = getChangeFunc(resourceType)
        // 上传眼镜、同版型自定义素材就不要自动选中
        if ((resourceType == RESOURCE_TYPE.GLASSES_TRYON)) {
            handelOpenDrawer('custom', RESOURCE_TYPE.GLASSES_TRYON, false)
            return
        }
        if ((resourceType == RESOURCE_TYPE.SIM_TRYON)) {
            handelOpenDrawer('custom', RESOURCE_TYPE.SIM_TRYON, false)
            return
        }
        onChange(pre => {
            if (multiple) {
                if (pre.length >= maxCount.current) return pre
            } else {
                // if (pre.length >= 1) return pre
            }
            const temp = [...pre]
            const custom = true
            const index = temp.findIndex(i => i.key == item.name)
            if (index == -1) { // 添加选项
                let _item = {
                    key: item.name,
                    title: item.attr.title,
                    url: item.imageUrl,
                    custom: 1, // 0-预设 1-自定义
                    attr: { ...item.attr }
                }
                const refImgConfig = (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) ? {
                    refImg: item.imageUrl,
                    refImgMask: item.attr.mask || null,
                    refImgProcessed: item.attr.imgProcessed || null,
                    refImgSize: {
                        width: item.attr.width,
                        height: item.attr.height
                    },
                    refImgLocalInfo: item.attr.objectLocationInfo || null,
                    refImgPrompt: item.attr.prompt,
                    // SAME_STYLE 需要将参考图加载到画布上，图像尺寸禁用; SIMILAR_STYLE 不需要
                    refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
                } : null

                // 上传商品要设置输出比例
                if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
                    const attr = _item.attr
                    setOutputRatio('custom')
                    setOutputWidth(attr?.width)
                    setOutputHeight(attr?.height)
                    setInputImageTransform()
                    // 复刻一份原数据的url，用于裁剪后重选原始参考图分辨率
                    _item = {
                        ..._item,
                        attr: {
                            ...attr,
                            originUrl: _item.url,
                            refCropUrl: _item.attr.refImage || _item.url,
                        }
                    }
                }

                // 单选模式，替换为新项；多选模式，追加新项
                if (multiple) {
                    temp.push(_item)
                } else {
                    temp.splice(0, temp.length, _item)
                }
                setRefImgConfig(refImgConfig)
                return temp
            } else {
                return pre
            }
        })
    }

    return {
        appendCustomMaterial,
    }
}

const UploadCustomMaterial = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        doUpload: handleUpload
    }))

    const {
        appendCustomMaterial
    } = useCustomMaterialAutoSelect(props.handelOpenDrawer)

    // useEffect(() => {
    //     const sendUrlToCustomMaterial = async ({url, resourceType}) => {
    //         try {
    //             if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
    //                 const file = await Utils.urlToFile(url)
    //                 const res = await doCustomShoes(file)
    //                 appendCustomMaterial(res.id, resourceType)
    //             } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
    //                 const file = await Utils.urlToFile(url)
    //                 const res = await doCustomTryonModel(file)
    //                 appendCustomMaterial(res.id, resourceType)
    //             }
    //         } catch (err) {
    //             message.error(err.message)
    //         }
    //     }
    //     eventBus.on("sendUrlToCustomMaterial", sendUrlToCustomMaterial)
    //     return () => {
    //         eventBus.off("sendUrlToCustomMaterial", sendUrlToCustomMaterial)
    //     }
    // }, [])

    const {
        getAiRemove
    } = useContext(GenerateContext)
    // 上传中
    const [loading, setLoading] = useState(false)
    // 新增模型弹窗
    const [open, setOpen] = useState(false)
    // 新增模型弹窗表单
    const modelFormRef = useRef()
    // 上传文件
    const uploadFileWithAntispamId = (file, figureCheck) => {
        return Utils.checkImageIslegal(file, 1, null, figureCheck).then(res => {
            if (!res) return false
            if (!res.isLegal) {
                PSAIModal.confirm({
                    content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                    okText: '知道了',
                    cancelText: '取消',
                    onOk() { },
                    onCancel() { },
                })
                return false
            } else {
                const { imageAntispamId, data } = res
                return {
                    url: data,
                    imageAntispamId
                }
            }
        })
    }
    // 获取文件名
    function getFilename(url) {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        return pathname.substring(pathname.lastIndexOf('/') + 1);
    }
    // 移除文件后缀
    function removeExtension(filename) {
        // 处理特殊文件名：'.' 和 '..'
        if (filename === '.' || filename === '..') return filename;

        const lastDot = filename.lastIndexOf('.');
        // 无后缀或隐藏文件（如 ".gitignore"）
        if (lastDot === -1 || lastDot === 0) return filename;

        return filename.substring(0, lastDot);
    }
    // 检查图片文件
    const checkImgaeFile = async (file, figureCheck) => {
        let url, imageAntispamId, width, height
        // 移除文件后缀
        const name = removeExtension(file.name)
        // 检查文件类型和宽高比
        const isNromal = await Utils.validateImageFile(file, true)
        if (!isNromal) return false
        // resize图片
        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
        if (!resizeRes || !resizeRes.success) throw new Error(resizeRes?.message)
        file = resizeRes.file
        width = resizeRes.width
        height = resizeRes.height
        // 上传图片
        const res = await uploadFileWithAntispamId(file, figureCheck)
        if (!res) return false
        url = res.url
        imageAntispamId = res.imageAntispamId
        return { name, url, imageAntispamId, width, height }
    }
    // 上传参考图时进行抠图优化
    const mattingRef = useRef()
    const [mattingOpen, setMattingOpen] = useState(false)
    const [mattingLoading, setMattingLoading] = useState(false)
    const [mattingParams, setMattingParams] = useState()
    const mattingCallback = useRef(null)
    const handleMattingOk = async () => {
        try {
            setMattingLoading(true)
            const mattingResult = await mattingRef.current.getMattingResult()
            if (!mattingResult) throw new Error('图片处理中，请稍后')
            const { refImg, refImgFile, refMask, refImgCropped, width, height, locationInfo, isPersonRef } = mattingResult
            // const imgErased = await getAiRemove(refImg, refMask)
            // if (!imgErased) return mattingCallback.current?.(false)
            mattingCallback.current?.({
                refMask,
                refImgCropped,
                // imgErased,
                locationInfo,
                isPersonRef
            })
        } catch (err) {
            console.error(err)
            message.warning(err.message)
            // mattingCallback.current?.(false)
        } finally {
            setMattingLoading(false)
        }
    }
    const handleMattingCancel = () => {
        mattingCallback.current?.(false)
    }
    const doMatting = async (src, width, height, isPerson = null) => {
        return new Promise((resolve, reject) => {
            setMattingOpen(true)
            if (isPerson === null || isPerson === undefined) {
                setMattingParams({
                    src,
                    width,
                    height,
                })
            } else {
                setMattingParams({
                    src,
                    width,
                    height,
                    isPerson
                })
            }
            mattingCallback.current = (res) => {
                mattingCallback.current = null
                setMattingOpen(false)
                if (res) {
                    resolve(res)
                } else {
                    resolve(false)
                }
            }
        })
    }

    // 上传参考图时进行编辑参考图尺寸
    const cropRef = useRef()
    const [cropOpen, setCropOpen] = useState(false)
    const [cropLoading, setCropLoading] = useState(false)
    const [cropParams, setCropParams] = useState()
    const cropCallback = useRef(null)
    const handleCropOk = async () => {
        try {
            setCropLoading(true)
            const cropResult = cropRef.current.getCropResult()
            if (Math.min(cropResult.width, cropResult.height) < 500) throw new Error('请上传尺寸在500x500以上的参考图片')
            let base64 = await Utils.cropImageBase64(cropParams.src, cropResult.x, cropResult.y, cropResult.width, cropResult.height)
            let file = Utils.convertBase64ToFile(base64)
            const width = cropResult.width
            const height = cropResult.height
            const res = await uploadFileWithAntispamId(file)
            if (!res) return cropCallback.current?.(false)
            const { url, imageAntispamId } = res
            cropCallback.current?.({
                url,
                imageAntispamId,
                width,
                height,
            })
        } catch (err) {
            console.error(err)
            message.warning(err.message)
            // cropCallback.current?.(false)
        } finally {
            setCropLoading(false)
        }
    }
    const handleCropCancel = () => {
        cropCallback.current?.(false)
    }
    const doCrop = async (src, width, height) => {
        return new Promise((resolve, reject) => {
            setCropOpen(true)
            setCropParams({
                src,
                width,
                height,
            })
            cropCallback.current = (res) => {
                cropCallback.current = null
                setCropOpen(false)
                if (res) {
                    resolve(res)
                } else {
                    resolve(false)
                }
            }
        })
    }

    /** 上传自定义视频 begin **/
    // 普通上传
    const doCustomVideoModel = async (file) => {
        let url, width, height
        const res = await Utils.validateVideoFile(file)
        if (!res.success) throw new Error(res.message)
        width = res.width
        height = res.height
        url = await Utils.uploadFile(file, true)
        if (!url) return false
        const res2 = await API.saveVideoMaterial({
            videoUrl: url,
            width: width,
            height: height,
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
    }
    /** 上传自定义视频 end **/
    /** 上传自定义鞋子 begin **/
    // 普通上传
    const doCustomShoes = async (file) => {
        const res = await checkImgaeFile(file, true) // figureCheck == true 表示公众任务检测
        if (!res) return false
        const { name, url } = res
        const res2 = await API.saveCustomShoesTryOn({
            tryOnImage: url,
            thumbnail: url,
            title: `自定义_${name}`,
            async: 1
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
    }
    /** 上传自定义鞋子 end **/
    /** 上传自定义模特 begin **/
    // 普通上传
    const doCustomTryonModel = async (file) => {
        const res = await checkImgaeFile(file, true) // figureCheck == true 表示公众任务检测
        if (!res) return false
        const { name, url, imageAntispamId } = res

        const res2 = await API.saveCustomTryOnModel({
            tryOnImage: url,
            thumbnail: url,
            imageAntispamId,
            title: `自定义_${name}`,
            async: 1
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
    }
    // 上传姿势裂变模特
    const doCustomPoseTryonModel = async (file) => {
        const res = await checkImgaeFile(file, true) // figureCheck == true 表示公众任务检测
        if (!res) return false
        const { name, url, width, height } = res

        const res2 = await API.saveCustomMaterialv2({
            func: IMAGE_TYPE.MODEL,
            type: RESOURCE_TYPE.POSE_TRYON,
            image: url,
            attr: {
                width: width,
                height: height,
                title: `自定义_${name}`,
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
    }
    // 上传眼镜试戴模特
    const doCustomGlassesTryonModel = async (file) => {
        const res = await checkImgaeFile(file, true) // figureCheck == true 表示公众任务检测
        if (!res) return false
        const { name, url, width, height } = res

        const res2 = await API.saveCustomMaterialv2({
            func: IMAGE_TYPE.MODEL,
            type: 'glasses',
            image: url,
            attr: {
                width: width,
                height: height,
                title: `自定义_${name}`,
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
    }
    // 上传同版型模特
    const doCustomSimTryonModel = async (file) => {
        const res = await checkImgaeFile(file, true) // figureCheck == true 表示公众任务检测
        if (!res) return false
        const { name, url, width, height } = res

        const res2 = await API.saveCustomMaterialv2({
            func: IMAGE_TYPE.MODEL,
            type: RESOURCE_TYPE.SIM_TRYON,
            image: url,
            attr: {
                width: width,
                height: height,
                title: `自定义_${name}`,
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
    }
    /** 上传自定义模特 end **/
    /** 上传自定义模特场景 begin **/
    // matting上传
    const doCustomModelScene = async (file) => {
        // 检查文件类型和宽高比
        const res = await checkImgaeFile(file)
        if (!res) return false
        const { name, url, imageAntispamId, width, height } = res
        if (Math.min(width, height) < 500) throw new Error('请上传尺寸在500x500以上的参考图片')
        // 检查是否包含人物
        // const personRes = await API.personCheck({ imageUrl: url })
        // if (personRes?.code != 0) throw new Error(personRes?.message)
        // const isPerson = personRes?.data

        // if (isPerson) { 移除带人像背景弹出的抠人像框
        //     const res = await doMatting(url, width, height, true)
        //     if (!res) return false
        //     const {refMask, refImgCropped, imgErased, locationInfo} = res
        //     const res2 = await API.saveCustomMaterial({
        //         func: IMAGE_TYPE.MODEL,
        //         type: "background",
        //         image: url,
        //         imageAntispamId: imageAntispamId,
        //         attr: {
        //             title: `自定义_${name}`,
        //             width: width,
        //             height: height,
        //             version: 3,
        //             mask: refMask,
        //             imgProcessed: refImgCropped,
        //             imgErased: imgErased, // 擦除后图片
        //             objectLocationInfo: locationInfo,
        //             personCheck: true
        //         }
        //     })
        //     if (res2.code != 0) throw new Error(res2.message)
        //     return res2.data
        // } else {
        const res2 = await API.saveCustomMaterialv2({
            func: IMAGE_TYPE.MODEL,
            type: "background",
            image: url,
            imageAntispamId: imageAntispamId,
            attr: {
                title: `自定义_${name}`,
                width: width,
                height: height
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        return res2.data
        // }
    }
    /** 上传自定义模特场景 end **/
    /** 上传自定义模特 begin */
    // 弹窗上传
    const handleNewModel = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleNewModel())
        if (!status) return
        setOpen(true)
    }
    const handelOk = async () => {
        try {
            setLoading(true)
            const res = await modelFormRef.current.onSubmit()
            if (res) {
                appendCustomMaterial(res, RESOURCE_TYPE.MODEL)
                message.success('模特添加成功')
                // sessionStorage.setItem('hsf_model_id', res)
                setOpen(false)
                eventBus.emit('updateCustomMaterial')
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }
    /** 上传自定义模特 end */

    /** 上传自定义商品场景-拍同款 begin */
    // matting上传
    const doCustomCommoditySceneForSameStyle = async (file) => {
        // 检查文件类型和宽高比
        const res = await checkImgaeFile(file)
        if (!res) return false
        const { name, url, imageAntispamId, width, height } = res
        if (Math.min(width, height) < 500) throw new Error('请上传尺寸在500x500以上的参考图片')
        if (Boolean) {
            const res = await doMatting(url, width, height)
            if (!res) return false
            const { refMask, refImgCropped, imgErased, locationInfo, isPersonRef } = res
            const res2 = await API.saveCustomMaterialv2({  // 原接口
                func: IMAGE_TYPE.COMMODITY,
                type: "background",
                image: url,
                imageAntispamId: imageAntispamId,
                attr: {
                    title: `自定义_${name}`,
                    width: width,
                    height: height,
                    version: 3,
                    mask: refMask,
                    imgProcessed: refImgCropped,
                    objectLocationInfo: locationInfo,
                    personCheck: isPersonRef,
                }
            })
            if (res2?.code != 0) throw new Error(res2?.message)
            return res2.data
        }
    }
    /** 上传自定义商品场景-拍同款 end */

    /** 上传自定义商品场景-相似风格 begin */
    // crop上传
    const doCustomCommoditySceneForSimilarStyle = async (file) => {
        // 检查文件类型和宽高比
        console.log('hahahahahha')
        const res = await checkImgaeFile(file)
        if (!res) return false
        const { name, url, imageAntispamId, width, height } = res
        if (Math.min(width, height) < 500) throw new Error('请上传尺寸在500x500以上的参考图片')
        if (Boolean) {
            const res2 = await API.saveCustomMaterialv2({
                func: IMAGE_TYPE.COMMODITY,
                type: "background",
                image: url,
                imageAntispamId: imageAntispamId,
                attr: {
                    title: `自定义_${name}`,
                    width: width,
                    height: height,
                    version: 1
                }
            })
            if (res2?.code != 0) throw new Error(res2?.message)
            return res2.data
        }
    }
    /** 上传自定义商品场景-相似风格 end */

    const handleUpload = async (file, resourceType, commoditySceneMode) => {
        if (!(file instanceof File)) { // 处理来自sendUrlToCustomMaterial的url参数
            file = await Utils.urlToFile(file)
        }
        if (resourceType == RESOURCE_TYPE.MODEL) {
            handleNewModel()
        } else if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            const res = await doCustomVideoModel(file)
            if (!res) return false
            // console.log('doCustomVideoModel', res)
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
            const res = await doCustomShoes(file)
            if (!res) return false
            // console.log('doCustomShoes', res)
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
            const res = await doCustomTryonModel(file)
            if (!res) return false
            // console.log('doCustomTryonModel', res)
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.POSE_TRYON) {
            const res = await doCustomPoseTryonModel(file)
            if (!res) return false
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.GLASSES_TRYON) {
            const res = await doCustomGlassesTryonModel(file)
            if (!res) return false
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
            const res = await doCustomSimTryonModel(file)
            if (!res) return false
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.MODEL_SCENE || resourceType == RESOURCE_TYPE.TRYON_SCENE) {
            const res = await doCustomModelScene(file)
            if (!res) return false
            // console.log('doCustomModelScene', res)
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && commoditySceneMode == COMMODITY_SCENE_MODE.SAME_STYLE) {
            const res = await doCustomCommoditySceneForSameStyle(file)
            if (!res) return false
            // console.log('doCustomCommoditySceneForSameStyle', res)
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && commoditySceneMode == COMMODITY_SCENE_MODE.SIMILAR_STYLE) {
            const res = await doCustomCommoditySceneForSimilarStyle(file)
            if (!res) return false
            // console.log('doCustomCommoditySceneForSimilarStyle', res)
            appendCustomMaterial(res.id, resourceType)
            eventBus.emit('updateCustomMaterial')
            return res
        } else {
            throw new Error('暂不支持')
        }
    }

    return (
        <>
            <PSAIModal
                getContainer={document.body}
                title="创建模特"
                maxWidth={594}
                open={open}
                confirmLoading={loading}
                okText="创建模特"
                onOk={handelOk}
                onCancel={() => setOpen(false)}
            >
                <CustomModelForm ref={modelFormRef} />
            </PSAIModal>
            <PSAIModal
                title='编辑背景尺寸'
                open={cropOpen}
                maskClosable={false}
                closable={false}
                maxWidth={548}
                onCancel={handleCropCancel}
                confirmLoading={cropLoading}
                onOk={handleCropOk}
            >
                <div style={{ padding: '20px' }}>
                    <Crop
                        ref={cropRef}
                        cropParams={cropParams}
                    />
                </div>
            </PSAIModal>
            <PSAIModal
                title='上传背景'
                open={mattingOpen}
                maskClosable={false}
                closable={false}
                maxWidth={548}
                onCancel={handleMattingCancel}
                confirmLoading={mattingLoading}
                onOk={handleMattingOk}
            >
                <div style={{ padding: '20px' }}>
                    <Matting
                        ref={mattingRef}
                        cropParams={mattingParams}
                    />
                </div>
            </PSAIModal>
        </>
    )
})

export default UploadCustomMaterial
